export const SAUCES = [
  'Aliquam risus tortor, fermentum at ultrices eu',
  'Aliquam mollis vehicula efficitur',
  'Fusce ornare ipsum',
];
